/* eslint-disable import/no-anonymous-default-export */
export default {
  header: {
    home: 'Home',
    product: 'Our product',
    devex: 'DevEx & IDP',
    astrolabe: 'Astrolabe IDP',
    team: 'Our team',
    contact: 'Get Started'
  },
  footer: {
    language: 'Language',
    termsOfUse: 'Terms of use',
    privacyStatement: 'Privacy statement',
    cookiePreferences: 'Cookie preferences',
    description: 'Astrolabe is an Internal Developer Portal developed and designed using Backstage©, by Forge IT'
  },
  hero: {
    title: 'Astrolabe',
    subtitle: 'Internal Developer Portal',
    description1: 'Developed and designed using',
    description2: 'for developer experience enhancement.'
  },
  ourProduct: {
    title: 'Our Product',
    description1: 'Our Internal Developer Portal (IDP), based on the open-source Backstage engine, is designed to centralize the tools, documentations and technical resources necessary for developer.',
    description2: 'We provide a solution easy-to-use, secured and customizable for our customers.',
    roi: {
      title: 'Your R.O.I',
      subtitle: 'Key metrics with an IDP',
      onboarding: 'reduction in onboarding time for new developers',
      incidents: 'reduction in production incidents',
      deployment: 'reduction in deployment time',
      development: 'increase in effective development time'
    },
    cards: {
      openSource: {
        title: 'Open Source',
        description: 'Massive community support and open source brings flexibility and continuous innovation.'
      },
      security: {
        title: 'Security and reliability',
        description: 'Secured SaaS Platform',
        subDescription: '(Network, Data, Backup).'
      },
      ux: {
        title: 'UX / UI',
        description: 'Interface optimized, data personalized.'
      },
      modular: {
        title: 'Modular architecture',
        description: 'Natively plugins-based architecture.'
      },
      popularity: {
        title: 'Popularity',
        description: 'Already adopted and used by many developers.'
      },
      accessibility: {
        title: 'Accessibility',
        description: 'Configuration, plugins accessible in interface, no-code, no service interruption.'
      },
      updated: {
        title: 'Updated',
        description: 'Tools upgrades managed by our team'
      }
    }
  },
  devEx: {
    title: 'DevEx & IDP',
    developerExperience: {
      title: 'Developer Experience',
      description1: 'Developer Experience is a set of interactions, tools, processes and environments that influence the way of developers work and create software.',
      description2: 'A good DevEx aims to make the work of developers fluid, productive and enjoyable, by offering:',
      listItems: {
        0: 'Intuitive and efficient tools,',
        1: 'Clear documentation,',
        2: 'Simplified access to resources,',
        3: 'And processes that reduce technical or organizational obstacles'
      }
    },
    backstage: {
      title: 'Backstage',
      description: 'is an open-source Framework developed by Spotify to implement an IDP.',
      listItems: {
        0: 'Applications catalog with dependency graphs',
        1: 'Create a new Git repo based on templates',
        2: 'Integrate with your CI/CD',
        3: 'Trigger a build and show build history status',
        4: 'Follow deployment version by environment',
        5: 'Centralize technical documentation',
        6: 'Collect health issues & metrics for your components'
      }
    },
    growth: {
      title: 'Growth and Adoption',
      emergingMarket: {
        title: 'Emerging Market:',
        text: 'The IDP market is experiencing significant growth, driven by the adoption of DevOps practices and the increasing complexity of cloud infrastructures'
      },
      trend: {
        title: '2024 Trend:',
        text: 'Surveys indicate that 85% of organizations have already implemented or plan to adopt an IDP within the next year, particularly in tech-driven industries'
      },
      enterprise: {
        title: 'Enterprise Adoption:',
        text: 'Mid-sized and large enterprises are leading the charge, focusing on reducing time-to-market and enhancing developer productivity'
      }
    },
    keyDrivers: {
      title: 'IDP Key Drivers',
      simplification: {
        title: 'Need for Simplification:',
        text: 'IDPs simplify development pipelines by providing standardized, ready-to-use environments for developers, reducing friction in workflows'
      },
      devops: {
        title: 'Impact of DevOps and micro-services:',
        text: 'The rise of micro-services and orchestration tools increases the demand for IDPs to simplify the management of complex infrastructures'
      },
      objective: {
        title: 'Core Objective:',
        text: 'Automating repetitive manual tasks and offering self-service, scalable environments to empower developers and boost agility in software delivery'
      }
    }
  },
  astrolabe: {
    title: 'Extra native features',
    subtitle: 'compared to Backstage',
    features: {
      pluginsManagement: 'Plugins management in UI',
      usersGroups: 'Users & Groups management',
      customDashboard: 'Custom dashboard',
      releasesManagement: 'Releases management',
      scorecard: 'Scorecard',
      gamification: 'Gamification',
      doraMetrics: 'DORA metrics',
      andMore: 'And more...'
    }
  },
  ourTeam: {
    title: 'About Our Services & Expertise',
    description: 'We support you throughout this transformation:',
    steps: {
      audit: 'Audit',
      integration: 'Integration',
      changeManagement: 'Change management & Training',
      support: 'Support & Technical expertise'
    },
    expertise: {
      introduction: 'Our team drives your success by leveraging our expertise in:',
      items: {
        devEx: 'Developer experience, optimizing workflows and enhancing productivity',
        cicd: 'CI/CD & Industrialization, accelerating development cycles and improving efficiency',
        devops: 'DevOps, fostering collaboration and automating processes for continuous innovation',
        security: 'Security, ensuring robust protection with the highest industry standards'
      }
    }
  },
  contactUs: {
    title: 'Ready to boost your DevEx?',
    subtitle: 'Let\'s qualify your needs',
    button: 'Start assessment'
  }
}; 